const React = require('react');
const classNames = require('classnames');
const PropTypes = React.PropTypes;
const SpringClickGroup = require('./spring-click-group.react');
const Loader = require('./loader.react');
const SpringsMixin = require('../mixins/springs');

const PopoverActionBar = React.createClass({

  propTypes: {
    isLoading: PropTypes.bool,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        handler: PropTypes.func.isRequired,
        modifiers: PropTypes.arrayOf(
          PropTypes.oneOf(['confirm', 'reject', 'primary', 'rightAligned', 'disabled'])
        ),
      })
    ).isRequired,
  },

  mixins: [
    SpringsMixin([]),
  ],

  getDefaultProps() {
    return {
      isLoading: false,
      actions: [],
    };
  },

  render() {
    const { actions, isLoading } = this.props;
    const actionsContent = isLoading ? <Loader /> : actions.map((action) => {
      const actionClassNames = classNames(
        'PopoverActionBar-action',
        ...(action.modifiers || []).map(m => `PopoverActionBar-action--${m}`)
      );

      return (
        <a className={ actionClassNames } key={ action.key } onClick={ action.handler }>
          { action.label }
        </a>
      );
    });

    const springStyle = {
      display: 'flex',
      width: '100%',
    };

    return (
      <div className="PopoverActionBar">
        <SpringClickGroup
          context={ this }
          style={ springStyle }
        >
          { actionsContent }
        </SpringClickGroup>
      </div>
    );
  },

});

module.exports = PopoverActionBar;
